import * as y from "yup"

export type Ok<A> = {_tag: "Ok"; data: A}
export type Err = {_tag: "Err"; errors: string[]}

/**
 * Validate a value against a given schema
 */
export function tryValidate<A>(schema: y.ObjectSchema<A>) {
  return (value: unknown): Ok<A> | Err => {
    try {
      const valid = schema.validateSync(value as A, {abortEarly: false})
      return {_tag: "Ok", data: valid as A}
    } catch (e: any) {
      return {_tag: "Err", errors: e.errors}
    }
  }
}

type Invalid = {
  original: unknown
  errors: string[]
}

/**
 * Validate an array of values against a schema
 */
export function groupValid<A>(schema: y.ObjectSchema<A>) {
  return (values: unknown[]): {valid: A[]; invalid: Invalid[]} => {
    const output: {valid: A[]; invalid: Invalid[]} = {
      valid: [],
      invalid: []
    }
    for (const value of values) {
      const validated = tryValidate(schema)(value)
      if (validated._tag == "Ok") {
        output.valid.push(validated.data)
      } else {
        output.invalid.push({original: value, errors: validated.errors})
      }
    }

    return output
  }
}
